import { Component, OnInit} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { CalendarsService } from '@finder/features/calendars/services/calendar.service';

@Component({
    selector: 'finder-date-picker-modal',
    templateUrl: './date-picker-modal.component.html',
    styleUrls: ['./date-picker-modal.component.scss']
})
export class DatePickerModalComponent implements ModalChildComponent, OnInit {

    parentComponent: ModalComponent;
    data: any;

    selectedDate: Date = new Date();

    private destroy$ = new Subject<void>();

    constructor(
        private calendarService: CalendarsService,
    ) { }

    ngOnInit() {
        this.calendarService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.selectedDate = this.calendarService.selectedDate;
            });
    }

    onDateChanged(date) {
        this.selectedDate = date;
        this.calendarService.emitDate(date);
    }

    dismiss() {
        this.parentComponent.dismiss();
    }
}
